// Navigation utilities for history-based routing (without hash)

export const navigateTo = (path: string) => {
    window.history.pushState(null, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
};

export const getCurrentPath = (): string => {
    return window.location.pathname;
};

export const isActivePath = (path: string): boolean => {
    return window.location.pathname === path || window.location.pathname.startsWith(path + '/');
};
